
export default {
  props: {
    section: {
      type: Object,
      required: true
    }
  }
}
